import SanityParagraph from 'app/atoms/Sanity/SanityParagraph/SanityParagraph';
import SanitySubHeader from 'app/atoms/Sanity/SanitySubHeader/SanitySubHeader';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { sanityDataset, sanityImagesBaseUrl, sanityProjectId } from 'sanity.io/config';
import { SanityEventCityImage, SanityEventCityText } from '../HolidayLikeALocal.types';
import { parseCityImg } from '../HolidayLikeALocalImage/HolidayLikeALocalImage';
import './HolidayLikeALocalCard.scss';

interface HolidayLikeALocalCardProps {
  text: SanityEventCityText[];
  image: SanityEventCityImage;
  imageHeader?: string;
  innerClass?: string;
}

function HolidayLikeALocalCard({ text, image, imageHeader, innerClass }: HolidayLikeALocalCardProps) {
  return (
    <div className="holiday-like-a-local-card p-2 m-2">
      <div className="col-12 px-0 holiday-like-a-local-card-image-container">
        <LazyLoadImage
          src={`${sanityImagesBaseUrl}/${sanityProjectId}/${sanityDataset}/${parseCityImg(image)}`}
          alt={'holiday image'}
          className={`holiday-like-a-local-card-image ${innerClass}`}
        />
        {!!imageHeader && <SanitySubHeader subHeader={imageHeader} />}
      </div>
      <SanityParagraph body={text} />
    </div>
  );
}
export default HolidayLikeALocalCard;
